import { getFullName, useNameList } from '@ben/common/names';
import MantineTooltip from '@ben/orion/mantine-tooltip';
import { TypographyVariant } from '@ben/orion/typography';
import { memo } from 'react';
import { TitleCell } from '../title-cell';

interface NameListCellProps {
  names?: { firstName?: string; lastName?: string; email?: string }[];
  allowPreferredName?: boolean;
}

const NameListCell = ({
  names,
  allowPreferredName = false,
}: NameListCellProps) => {
  const nameList = useNameList(names, undefined, allowPreferredName);

  if (!names) {
    return;
  }

  if (names?.length === 1) {
    return (
      <TitleCell
        title={getFullName(names[0], allowPreferredName)}
        subtitle={names[0].email}
      />
    );
  }

  const tooltipText =
    names?.length > 1
      ? names
          .map(
            (name) => `${getFullName(name, allowPreferredName)} (${name.email})`
          )
          .join(',\n')
      : undefined;

  return (
    <MantineTooltip label={tooltipText} maw={500}>
      <TitleCell
        title={nameList}
        titleVariant={TypographyVariant.bodyMd2}
        showTooltip={false}
      />
    </MantineTooltip>
  );
};

export default memo(NameListCell);
